/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

'use strict';

/**
* AngularJs component that displays the fluctuating lines for enabling the Archive Feature.
*
* @author Tyrus Malmstrom.
*/

angular.module('bulbApp.organizationModule')
.component('archiveLoadingIndicator', {
  templateUrl: 'ajs/organization/organization-archive-loading-indicator.html',
});
